import axios from 'axios';

async function ObtenerLocalidades(prmIdPais: number, prmIdLocalidad: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_localidades"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "idPais": prmIdPais,
            "idProvincia": prmIdLocalidad
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerLocalidades;